import React, { useState } from "react";
import MemberTypeManagement from "./components/MemberTypeManagement";

type TabType = "member-types";

const MasterData: React.FC = () => {
  const [activeTab, setActiveTab] = useState<TabType>("member-types");

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-950 py-8 px-4">
      <div className="max-w-[1600px] mx-auto">
        {/* Header Section */}
        <div className="mb-8">
          <div className="flex items-center justify-between mb-6">
            <div>
              <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-2">
                Master Data
              </h1>
              <p className="text-gray-600 dark:text-gray-300">
                Manage system master data and lookup values
              </p>
            </div>
          </div>
        </div>

        <div className="bg-white dark:bg-gray-800 rounded-xl shadow-lg border border-gray-200 dark:border-gray-700">
          <div className="border-b border-gray-200 dark:border-gray-700">
            <nav className="flex space-x-4 px-6">
              <button
                onClick={() => setActiveTab("member-types")}
                className={`px-4 py-3 text-sm transition-colors ${
                  activeTab === "member-types"
                    ? "text-gray-900 dark:text-white font-bold border-b-2 border-blue-500"
                    : "text-gray-600 dark:text-gray-300 hover:text-gray-900 dark:hover:text-white"
                }`}
              >
                Member Types
              </button>
            </nav>
          </div>

          <div className="p-6">
            {activeTab === "member-types" && <MemberTypeManagement />}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MasterData;
